module.exports = __webpack_public_path__ + "89c81a3cbc00c32cbe1b28561029be0d.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/media/fonts/Poppins/Poppins-RegularItalic.ttf
// module id = 1261
// module chunks = 0